import React from 'react';
import styles from './styles.module.scss';
import { StyledTableCell, StyledTableRow } from 'components/StyledComponents';
import { TableWrapper } from 'components/SummaryComponents';
import { Table, TableBody, TableHead } from '@material-ui/core';

export default function LooseItemsTable({ looseItems }) {
  if (!looseItems?.length) return null;

  const rows = looseItems.flatMap((looseItem) =>
    looseItem.locations.map((location, index) => ({
      ...location,
      looseItemName: looseItem.name,
      isFirst: index === 0,
      rowSpan: looseItem.locations.length
    }))
  );

  return (
    <TableWrapper>
      <Table>
        <TableHead>
          <StyledTableRow>
            <StyledTableCell className={styles.loose_items__name_head_cell}>
              Loose Item
            </StyledTableCell>
            <StyledTableCell className={styles.loose_items__location_head_cell}>
              Point of origin (Sublocation) [Asset]
            </StyledTableCell>
            <StyledTableCell className={styles.loose_items__qty_head_cell}>QTY</StyledTableCell>
            <StyledTableCell className={styles.loose_items__baa_head_cell}>
              From BAA
            </StyledTableCell>
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <StyledTableRow key={row.id} className={styles.loose_items__body_row}>
              {row.isFirst && (
                <StyledTableCell className={styles.loose_items__name_cell} rowSpan={row.rowSpan}>
                  {row.looseItemName || ''}
                </StyledTableCell>
              )}
              <StyledTableCell className={styles.loose_items__location_cell}>
                {row.pointOfOrigin || ''}
              </StyledTableCell>
              <StyledTableCell className={styles.loose_items__qty_cell}>
                {row.selectedQuantity || 0}
              </StyledTableCell>
              <StyledTableCell className={styles.loose_items__baa_cell}>
                {row.selectedByAheadAccount || 0}
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableWrapper>
  );
}
